
import { apiClient } from 'model/axiosConfig';
import { typePosSettingsEpsItem } from 'model/dashboardEPS/dEpsReducer';

export type typePosSettingsItemPutRequest ={
    id: typePosSettingsEpsItem['id'],
    posId: typePosSettingsEpsItem['posId'],
    paymentSystemObjectsIds: string[]
}


// get merchant's available eps
export const getMerchantsEps = async () => {

    const path = '/eps/api/v1/merchantPaymentSystem'
    const config = {
        headers: {},
    }

    try {
        return await apiClient.get(path, config)
    } catch (error) {
        return error
    }
}

// get terminal's list
export const getTerminalsList = async () => {

    const path = '/product/pos/search'
    const config = {
        headers: {},
    }
    const data = {
        filters: {
            active: true
        },
        sortFilter: {
            direction: 'ASC',
            column: 'store'
        }
    }


    try {
        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}

// get terminals with eps
export const getPosSettingsList = async () => {

    const path = '/eps/api/v1/posSettings'
    const config = {
        headers: {},
    }

    try {
        return await apiClient.get(path, config)
    } catch (error) {
        return error
    }
}


// get payment object from external eps
export const getPaymentSystemOfficeFromEps = async (payload:{paymentSystemId: string,merchantID : string }) => {

    const path = `/eps/api/v1/paymentSystemObject/paymentSystem/${payload.paymentSystemId}/merchant/${payload.merchantID}`
    const config = {
        headers: {},
    }

    try {
        return await apiClient.get(path, config)
    } catch (error) {
        return error
    }
}


// get all payment system object from tinda
export const getPaymentSystemObjectFromTinda = async () => {

    const path = '/eps/api/v1/paymentSystemObject'
    const config = {
        headers: {},
    }

    try {
        return await apiClient.get(path, config)
    } catch (error) {
        return error
    }
}


// create new payment system object in tinda
export const createPSObjectInTinda = async (payload: {paymentSystemId: string, externalId: string}) => {

    const path = '/eps/api/v1/paymentSystemObject'
    const config = {
        headers: {},
    }

    const data = {
        "externalId": payload.externalId,
        "paymentSystem": {
            "id": payload.paymentSystemId
        }
    }

    try {
        return await apiClient.post(path,data, config)
    } catch (error) {
        return error
    }
}


// create new payment system object in tinda
export const addPosSettingsForTerminal = async (payload: {terminalIds: string[], psObjectId: string}) => {

    const path = `/eps/api/v1/paymentSystemObject/${payload.psObjectId}/linkPosTerminals`
    const config = {
        headers: {},
    }

    const data =payload.terminalIds

    try {
        return await apiClient.put(path,data, config)
    } catch (error) {
        return error
    }
}

// disconnect pos from payment system  --  edit posSettings for selected pos
export const disconnectPosItem = async (payload: {posSettings: typePosSettingsItemPutRequest}) => {

    const path = `/eps/api/v1/posSettings`
    const config = {
        headers: {},
    }

    const data =payload.posSettings

    try {
        return await apiClient.put(path,data, config)
    } catch (error) {
        return error
    }
}

//bulk disconnect pos from payment system  -- bulk edit posSettings for selected pos
export const disconnectPosItemBulk = async (payload: {posSettings: typePosSettingsItemPutRequest[]}) => {

    const path = `/eps/api/v1/posSettings/bulk`
    const config = {
        headers: {},
    }

    const data =payload.posSettings

    try {
        return await apiClient.put(path,data, config)
    } catch (error) {
        return error
    }
}

